import { render, staticRenderFns } from "./destroy-modal.vue?vue&type=template&id=f685be42&"
import script from "./destroy-modal.vue?vue&type=script&lang=js&"
export * from "./destroy-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports